import { Severity } from '../../types/alerts';
import { AlertTriangle, Flame, AlertCircle } from 'lucide-react';

interface SeveritySelectorProps {
  selectedSeverity: Severity | null;
  onSeverityChange: (severity: Severity | null) => void;
}

const severities: { type: Severity; icon: typeof AlertTriangle; label: string; color: string }[] = [
  { type: 'Critical', icon: Flame, label: 'Critical', color: 'text-red-500' },
  { type: 'High', icon: AlertTriangle, label: 'High', color: 'text-orange-500' },
  { type: 'Medium', icon: AlertCircle, label: 'Medium', color: 'text-yellow-500' },
];

export function SeveritySelector({ selectedSeverity, onSeverityChange }: SeveritySelectorProps) {
  const handleClick = (type: Severity) => {
    // Toggle: if already selected, unselect (null means show all)
    if (selectedSeverity === type) {
      onSeverityChange(null);
    } else {
      onSeverityChange(type);
    }
  };

  return (
    <div className="flex items-center gap-2 lg:gap-4 p-1.5 bg-muted/30 rounded-xl">
      {severities.map((severity) => {
        const Icon = severity.icon;
        const isSelected = selectedSeverity === severity.type;
        return (
          <button
            key={severity.type}
            onClick={() => handleClick(severity.type)}
            className={`
              relative flex items-center justify-center gap-2 px-4 py-1.5 rounded-lg text-[13px] font-medium transition-all duration-300
              ${isSelected 
                ? 'bg-gradient-to-br from-card to-card/80 text-foreground shadow-sm ring-1 ring-border/50 scale-105' 
                : 'text-muted-foreground hover:text-foreground hover:bg-card/50 hover:scale-105'
              }
            `}
          >
            <Icon 
              className={`h-4 w-4 transition-all duration-300 ${severity.color} ${
                isSelected ? '' : 'opacity-40'
              }`}
            />
            <span>{severity.label}</span>
          </button>
        );
      })}
    </div>
  );
}
